module.exports = __webpack_public_path__ + "img/edit2_w.9eaafc3a.svg";